module.exports = __webpack_public_path__ + "img/benefit-card-dent.fc2c0bce.svg";